import React from "react"
import ReactPaginate from "react-paginate"
import styles from "./Pagination.module.css"
import { GrPrevious, GrNext } from "react-icons/gr";



export const Pagination = ({
    pageCount,
    onPageChange = () => {},
    numberPage = 0
}) => {

    return (
        <ReactPaginate
              previousLabel={<GrPrevious size={20} color={numberPage > 0 ? "black" : "#ccc"}/>}
              nextLabel={<GrNext size={20} color={numberPage + 1 < pageCount ? "black" : "#ccc"}/>}
              breakLabel={"..."}
              breakClassName="break-me"
            //   marginPagesDisplayed={2}
              pageCount={pageCount || 1}
            //   pageRangeDisplayed={5}
              onPageChange={onPageChange}
              containerClassName={styles.pagination}
            //   subContainerClassName="pages pagination"
              activeClassName={styles.active}
              forcePage={numberPage}
            />
    )
}